// extracted by mini-css-extract-plugin
export default {"tab":"tab-NYqUx subjectTab-G0wfI","text":"text-gZDqp text-jjgYT"};